import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {DialogBody} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Divider} from '@/components/ui/divider/Divider'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {formatDate, formatLocaleDate} from '@/dayjs'
import {AgendaEventGeneric} from '@/features/agenda/types'
import {useTranslation} from '@/translations/i18n'

export const AgendaGenericEventDetailsDialogBody = ({event}: {event: AgendaEventGeneric}) => {
    const {t} = useTranslation()
    const consultant = event.eventConsultants?.[0]

    return (
        <DialogBody>
            {consultant && (
                <Grid columns={2}>
                    <DetailsField>
                        <Text size="textSm" palette="neutral" shade="500" weight="500">
                            {t('commons:healthcare_professional', {count: 1})}
                        </Text>
                        <Text size="textSm" weight="500">
                            {consultant.user.fullName}{' '}
                            {consultant.user.specialization ? `(${consultant.user.specialization})` : ''}
                        </Text>
                    </DetailsField>
                </Grid>
            )}
            <Divider direction="horizontal" />
            <Grid columns={3} gap={4}>
                <DetailsField>
                    <Text size="textSm" palette="neutral" shade="500" weight="500">
                        {t('commons:date')}
                    </Text>
                    <Text size="textSm" weight="500" style={{textTransform: 'capitalize'}}>
                        {formatLocaleDate(event.date, 'dddd D MMMM')}
                    </Text>
                </DetailsField>
                {event.duration !== 720 ? (
                    <>
                        <DetailsField>
                            <Text size="textSm" palette="neutral" shade="500" weight="500">
                                {t('agenda:start_time')}
                            </Text>
                            <Text size="textSm" weight="500">
                                {event.time
                                    ? formatLocaleDate(`${formatDate(event.date, 'YYYY-MM-DD')} ${event.time}`, 'H:mm')
                                    : '-'}
                            </Text>
                        </DetailsField>
                        <DetailsField>
                            <Text size="textSm" palette="neutral" shade="500" weight="500">
                                {t('commons:duration')}
                            </Text>
                            <Text size="textSm" weight="500">
                                {t('commons:duration_minutes', {value: event.duration})}
                            </Text>
                        </DetailsField>
                    </>
                ) : (
                    <>
                        <DetailsField>
                            <Text size="textSm" palette="neutral" shade="500" weight="500">
                                {t('commons:duration')}
                            </Text>
                            <Text size="textSm" weight="500">
                                {t('commons:all_day_availability')}
                            </Text>
                        </DetailsField>
                    </>
                )}
            </Grid>
            <Divider direction="horizontal" />
            <DetailsField>
                <Text size="textSm" palette="neutral" shade="500" weight="500">
                    {t('commons:notes')}
                </Text>
                <Text size="textSm" weight="500">
                    {event.note ?? '-'}
                </Text>
            </DetailsField>
        </DialogBody>
    )
}
